var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.coordinatingProducts.length > 0
    ? _c(
        "div",
        {
          staticClass: "wf-product-tiles",
          class:
            "wf-product-tiles-view-mode-" +
            _vm.viewMode +
            " wf-product-tiles-tile-size-" +
            _vm.tileSize +
            " wf-product-tiles-display-mode-" +
            _vm.displayMode
        },
        [
          _c("section", { staticClass: "section-content" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "section-content-top" },
                [
                  _c(
                    "h2",
                    { staticClass: "secondary-heading" },
                    [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("learn-more-link")
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    _vm.displayMode === "slider"
                      ? ["wf-product-tiles-slider", "scroll-fade-right"]
                      : "wf-product-tiles-grid"
                },
                [
                  _vm._t(
                    "items",
                    _vm._l(_vm.coordinatingProducts, function(tile) {
                      return _c(
                        "div",
                        {
                          key: tile.coordinatingProductID,
                          staticClass:
                            "wf-product-tile wf-product-tile-coordinating-product description"
                        },
                        [
                          _c("div", { staticClass: "wf-product-tile-image" }, [
                            _c(
                              "div",
                              { staticClass: "wf-product-tile-image-swatch" },
                              [
                                _c("img", {
                                  staticClass: "image ",
                                  attrs: {
                                    src: _vm.getThumbnailImageUrl(
                                      tile.styleNumber,
                                      tile.colorNumber
                                    ),
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wf-product-tile-content" },
                            [
                              _c(
                                "div",
                                { staticClass: "wf-product-tile-title" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "stretched-link cart-item-model-no",
                                      attrs: {
                                        href: _vm.getProductDetailUrl(
                                          tile.styleNameURL,
                                          tile.styleNumber,
                                          tile.colorNumber
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(tile.colorName) +
                                          " " +
                                          _vm._s(tile.colorNumber) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "wf-product-tile-details" },
                                [
                                  _c("li", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(tile.productType) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      _vm._s(tile.styleName) +
                                        " " +
                                        _vm._s(tile.styleNumber)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  tile.collectionCode &&
                                  tile.collectionCode.description
                                    ? _c("li", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              tile.collectionCode.description
                                            ) +
                                            " collection\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      _vm._s(tile.customColorCount) +
                                        " swatch colors"
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  )
                ],
                2
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }